import { Api } from 'utils';

class ModeratorService {
	
	static get = async (params?: any) => Api.createResponse('client/moderators',params);
	static save = async (params?: any) => Api.createResponse('client/moderators/save',params);
	static getData = async (params?: any) => Api.createResponse('client/moderators/data',params);
	static delete = async (params?: any) => Api.createResponse('client/moderators/delete',params);
}

export default ModeratorService;